// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-ecommerce-footer',
    computed: {
        footerMenuEntriesRight() {
            return this.$appHost.store.getter("navigation/getMenu", "FOOTER").filter(e => e.alignment == 1);
        },
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    },
});
// #endregion
